import * as AuthActions from '../actions/authActions';
import * as InfoActions from '../actions/infoActions';
import {NotificationManager} from 'react-notifications';

const defaultState = {
    authorized: false,
    token: null,
    user: null,
    profile: null,
    loggingIn: false,
    errorMessage: null,
    message: null,
    passwordResetError: null,
    passwordResetCompleted: false,
    allCourses: [],
    codeSent: false,
    tasks: [],
    codeWrong: false,
    officialTests: [],
    allUsers: [],
    disableButton: false,
    modalDisplay: 0,
    modalLoading: false,
    deleteCounts: {},
    deleteFields: {
        users: 'Users',
        profiles: 'Profiles',
        courseUsers: 'Course Instances',
        logins: 'Logins',
        videoDiscussions: 'Video Comments',
        courseNotifications: 'Notifications',
        likes: 'Comment Likes',
        officialTests: 'Official Tests',
        videoQuestions: 'Video Questions',
        chapterTests: 'Tests',
        tasks: 'Tasks',
        logs: 'Logs',
        flags: 'Flags',
        userChapters: 'Chapter Instances',
        userSubjects: 'Subject Instances',
        userLectures: 'Lecture Instances',
    }
};

export default (state = defaultState, action) => {
    switch (action.type) {
        case 'RESET_MODAL_DISPLAY':
            return {
                ...state,
                modalDisplay: action.payload
            }
        case AuthActions.INITIAL_TASKS:
            return {
                ...state,
                tasks: action.payload
            }
            break;
        case 'SENDING_EMAIL':
            return {
                ...state,
                disableButton: true
            }
        case 'ACTION_AUTH_LOGIN_REQUEST':
            return {
                ...state,
                loggingIn: true
            }
        case 'ADD_CU_TO_PROFILE':
            return {
                ...state,
                profile: {
                    ...state.profile,
                    CourseUser: [action.payload]
                },
                user: {
                    ...state.user,
                    Profile: {
                        ...state.profile,
                        CourseUser: [action.payload] 
                    }
                }
            }
        case 'GOT_USERS':
            return {
                ...state,
                allUsers: action.skip ? state.allUsers.concat(action.payload) : action.payload
            }
        case 'SET_DELETING_LOADING':
            return {
                ...state,
                modalLoading: true,
                modalDisplay: 1,
            }
        case 'DELETED_USER':
            return {
                ...state,
                allUsers: state.allUsers.filter(p => p.id !== action.payload.id),
                deleteCounts: action.payload.deletedObjects,
                modalLoading: false
            }
        case AuthActions.OFFICIAL_TEST_ADDED:
            return {
                ...state,
                officialTests: state.officialTests.concat(action.payload)
            }
            break;
        case AuthActions.OFFICIAL_TEST_DELETED:
            let index = -1;
            state.officialTests.map((t, i) => {
                if(t.id === action.payload){
                    index = i;
                }
            })
            
            let OT = state.officialTests;
            if(index > -1){
                OT.splice(index, 1);
            }
            return {
                ...state,
                officialTests: OT
            }
            break;
        case AuthActions.OFFICIAL_TEST_UPDATED:
            return {
                ...state,
                officialTests: state.officialTests.map(t => {
                    if(t.id === action.payload.id){
                        return {
                            ...t,
                            ...action.payload
                        }
                    }else{
                        return {
                            ...t
                        }
                    }
                })
            }
            break;
        case AuthActions.OFFICIAL_TEST_RETRIEVED:
            return {
                ...state,
                officialTests: action.payload
            }
            break;
        case AuthActions.TOKEN_SENT:
            return {
                ...state,
                codeSent: true
            }
            break;
        case AuthActions.TOKEN_WRONG:
            return {
                ...state,
                codeWrong: true
            };
        case AuthActions.TOKEN_VERIFIED:
            return {
                ...state,
                user: {...state.user, user: {...state.user.user, emailVerified: true}},
                codeWrong: false
            }
        case AuthActions.TASK_UPDATED:
            return {
                ...state,
                tasks: state.tasks.map(t => {
                    if(t.id === action.payload.taskId){
                        return {
                            ...t,
                            ...action.payload.task
                        }
                    }else{
                        return t
                    }
                })
            }
            break;
        case AuthActions.TASK_ADDED:
            return {
                ...state,
                tasks: state.tasks.concat(action.payload.task)
                
                
            };
            break;
        case AuthActions.ACTION_AUTH_LOGIN_SUCCESS:
            return {
                ...state,
                authorized: true,
                token: action.payload.id,
                errorMessage: null,
                ...action.payload,
                profile: action.payload.user.user.Profile,
                passwordResetCompleted: false,
                loggingIn: false,
            };
        case AuthActions.ACTION_GOT_PROFILE:
            return {
                ...state,
                user: {...state.user,
                    user: {...state.user.user},
                    Profile: action.payload
                },
                profile: action.payload
            };
        case AuthActions.UPDATED_COURSE_USER:
            let CourseUsers = state.user.user.Profile.CourseUser.map(c => {
                if(c.id == action.payload.id){
                    return {
                        ...c,
                        completedSubjects: action.payload.completedSubjects,
                        completedChapters: action.payload.completedChapters,
                        completedChapterParts: action.payload.completedChapterParts,
                        currentSubject: action.payload.currentSubject,
                        currentChapter: action.payload.currentChapter,
                        currentChapterPart: action.payload.currentChapterPart
                    }
                }else{
                    return c;
                }
            })

            return {
                ...state,
                user: {
                    ...state.user,
                    user: {
                        ...state.user.user,
                        Profile: {
                            ...state.user.user.Profile,
                            CourseUser: CourseUsers
                        }
                    }
                }
            }
        case AuthActions.ACTION_UPDATED_USER:
            return {
                ...state,
                user: {...state.user, user: {
                    ...state.user.user,
                    ...action.payload
                }}
            };
        case AuthActions.ACTION_UPDATED_PROFILE:
            NotificationManager.success('Your profile information has been saved.', 'Saved');
            return {
                ...state,
                profile: action.payload,
                user: {
                    ...state.user,
                    Profile: action.payload
                }

            };
        case AuthActions.ACTION_AUTH_LOGOUT:
            return {
                ...state,
                authorized: false
            };
        case AuthActions.ACTION_AUTH_LOGIN_FAILURE:
            return {
                ...state,
                authorized: false,
                ...action.payload,
                loggingIn: false
            };
        case InfoActions.ACTION_BASIC_INFO_USER_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    ...action.payload
                },
            };
        case InfoActions.ACTION_CONTACTS_INFO_USER_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    infoContacts: {
                        ...state.user.infoContacts,
                        ...action.payload
                    },
                },
            };
        case InfoActions.ACTION_EDUCATION_INFO_USER_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    infoEducation: {
                        ...state.user.infoEducation,
                        ...action.payload
                    },
                },
            };
        case InfoActions.ACTION_CIRCUMSTANCES_INFO_USER_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    infoCircumstances: {
                        ...state.user.infoCircumstances,
                        ...action.payload
                    },
                },
            };
        case InfoActions.ACTION_LSAT_INFO_USER_UPDATE:
            return {
                ...state,
                user: {
                    ...state.user,
                    infoLSAT: {
                        ...state.user.infoLSAT,
                        ...action.payload
                    },
                },
            };
        case AuthActions.ACTION_AUTH_REGISTER_SUCCESS:
            return {
                ...state,
                authorized: true,
                ...action.payload,
                passwordResetCompleted: false
            };
        case AuthActions.ACTION_AUTH_PASSWORD_RESET_REQUESTED:
            return {
                ...state,
                ...action.payload,
                disableButton: false
            };
        case AuthActions.ACTION_AUTH_RESET_PASSWORD_FAILED:
            return {
                ...state,
                ...action.payload,
                disableButton: false
            };
        case AuthActions.ACTION_AUTH_PASSWORD_RESET_COMPLETED:
            return {
                ...state,
                ...state.payload,
                passwordResetCompleted: true
            };
        case AuthActions.ACTION_AUTH_CLEAR:
            return {
                ...state,
                ...defaultState
            }
        case AuthActions.ACTION_AUTH_RESET_PASSWORD_RESET_STATUS:
            return {
                ...state,
                message: null,
                passwordResetCompleted: false
            };
        case AuthActions.ACTION_GOT_ALL_COURSES:
            return {
                ...state,
                allCourses: action.payload
            };
        default:
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/store/reducers/authReducer.js